
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import Message from '@/components/message.vue';
	import Dialog from '@/components/dialog.vue';
  import {
    qyWeixinKfAccountqyWeixinKfAccountList,
    qyWeixinKfAccountsync,
    qyWeixinKfAccountqyWeixinKfAccountDelete,
    qyWeixinKfAccountqyWeixinKfAccountInfo,
    qyWeixinKfAccountqyWeixinKfAccountTeamByName,
    qyWeixinKfAccountqyWeixinKfAccountInfoSave
  } from "@/api/auth"
	import {
		UserModule
	} from "@/store/modules/user"
  
  import {
    memberdirectCompanyMemberList,
  } from '@/api/after_sales'
	import {
		handleClipboard
	} from '@/utils/clipboard'
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-message': Message,
			'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    private keyname = ''
    private keyteam = ''
    private keyservice = null
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
    private tablelist:any = []
    private tableloading = false

    private rowmsg:any = {}
    private delShow = false

    private editShow = false
    private kfmsg:any = {
      KfType:'',
      ServiceTeamList:[]
    }
    private editloading = false
    private allteam:any = []
    private serviceid = ''
    private fixservicelist = [
      {value:2,label:'售后客服'},
    ]

    private get servicelist(){
      // console.log(UserModule.mallInfo.OpenKfType)
      let list = [
        {value:1,label:'售前客服'},
        {value:2,label:'售后客服'},
      ]
      return list.filter(v=>{
        return UserModule.mallInfo.OpenKfType.some(x=>v.value==x)
      })
    }

    private mounted () {
      // this.synchronous()
      this.gettablelist()

    }

    private async confirmsave(){
      if(!this.kfmsg.KfType){
        this.$message.error('请选择客服类型')
        return
      }
      try{
        this.editloading = true
        let res = await qyWeixinKfAccountqyWeixinKfAccountInfoSave({
          ...this.kfmsg,
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.closeedit()
          this.gettablelist()
        }
      }finally{
        this.editloading = false
      }
    }
    private closeedit(){
      this.kfmsg = {
        KfType:'',
        ServiceTeamList:[]
      }
      this.serviceid = ''
      this.editShow = false
    }
    private closetag(e){
      this.kfmsg.ServiceTeamList.splice(e,1)
    }
    private joinmyteam(){
      if(!this.serviceid){
        this.$message.error('请选择团队')
        return 
      }else if(this.kfmsg.ServiceTeamList.find(v=>{return v.MemberId==this.serviceid})?.MemberId){
        this.$message.error('已负责该团队，请勿重新添加')
        return 
      }
      this.kfmsg.ServiceTeamList.push(this.allteam.find(v=>{return v.MemberId==this.serviceid}))
      this.serviceid = ''
    }
    private async getallteamlist(){
      try{
        let res = await memberdirectCompanyMemberList({})
        if(res.IsSuccess){
          this.allteam = res.Result.map(v=>{
            v.MemberId = v.Id
            return v
          })
        }
      }finally{
        //
      }
    }
    private async getkfdetail(){
      try{
        this.editloading = true
        let res = await qyWeixinKfAccountqyWeixinKfAccountInfo({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.kfmsg = res.Result
          this.kfmsg.KfType = this.kfmsg.KfType||''
        }
      }finally{
        this.editloading = false
      }
    }
    private edit(row){
      this.rowmsg = row
      this.editShow = true
      this.getkfdetail()
      this.getallteamlist()
    }
    private async confirmdel(){
      try{
        this.tableloading = true
        let res = await qyWeixinKfAccountqyWeixinKfAccountDelete({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private detele(row){
      this.rowmsg = row
      this.delShow = true
    }
    private copyaftersales(e,row){
      // console.log(row)
      handleClipboard(row.KfLinkUrl,e)
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res = await qyWeixinKfAccountqyWeixinKfAccountList({
          Keywords:this.keyname,
          TeamInfo:this.keyteam,
          KfType:this.keyservice,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keyname = ''
      this.keyteam = ''
      this.keyservice = null
      this.doSearch()
    }
    private async synchronous(){
      try{
        this.tableloading = true
        let res = await qyWeixinKfAccountsync({})
        if(res.IsSuccess){
          this.$message.success('数据同步成功')
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
  }
